import React from "react";
import {createListTitle} from "../../apps/searchResults/utils";
import {FormattedMessage} from "react-intl";

const ListingTitle = ({listingTitle, listingType}) => {
  if (!listingTitle) {
    return <FormattedMessage id="app.search.sell.results.title.default" defaultMessage="Sell Tickets"/>;
  }

  const {title, hasSuffix} = createListTitle({
    q: listingTitle,
    type: listingType
  });
  return hasSuffix ?
    <FormattedMessage id="app.search.sell.results.title.sellTickets" defaultMessage="Sell {title} Tickets" values={{title}}/> :
    <FormattedMessage id="app.search.sell.results.title.sell" defaultMessage="Sell {title}" values={{title}}/>;
};

export default ListingTitle;
